import './App.css';
import React from "react";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from '@mui/material/styles';
import { themeOptions } from "./assets/themeOptions";
import { AuthProvider } from './contexts/auth';
import CssBaseline from "@mui/material/CssBaseline";
import RoutesApp from './routes';

function App() {

  console.log(`VERSAO: ${process.env.REACT_APP_VERSAO}`)
  console.log(`url: ${window.location.hostname}`)
  return (
    <AuthProvider>
      <ThemeProvider theme={themeOptions}>
        <CssBaseline />
        <RoutesApp />
      </ThemeProvider>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
